// feature_img historically stored a bare FILENAME under the legacy editor
// upload dir (/marketing/branding/hotlink-ok/). SEO-mirrored articles store a
// FULL absolute URL (https://app.prigmar.com/uploads/generated/...). Blindly
// prefixing broke every mirrored article's header image (double-prefixed src).
// Prefix only legacy filenames; pass URLs and rooted paths through.
export default function articleImg(base, featureImg) {
  const f = String(featureImg || "");
  if (!f) return "";
  if (/^https?:\/\//i.test(f) || f.startsWith("/")) return f;
  return `${base}/marketing/branding/hotlink-ok/${f}`;
}
